(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mic-lock-region-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mic-lock-region-notice')) {
    class MicLockRegionNotice extends HTMLElement {
      static chosenCountry;
      static storageKey = 'mic-lock-delivery-country';

      connectedCallback() {
        this.countryField = this.querySelector('[data-country-field]');
        this.unavailable = this.querySelector('[data-region-unavailable]');
        this.checkoutHint = this.querySelector('[data-region-checkout]');
        if (!this.countryField || !this.unavailable || !this.checkoutHint) return;

        this.listeners?.abort();
        this.listeners = new AbortController();
        this.restrictedCountries = new Set(this.dataset.restrictedCountries.split(','));

        if (MicLockRegionNotice.chosenCountry === undefined) {
          try {
            MicLockRegionNotice.chosenCountry = sessionStorage.getItem(MicLockRegionNotice.storageKey) || '';
          } catch {
            MicLockRegionNotice.chosenCountry = '';
          }
        }
        this.update(MicLockRegionNotice.chosenCountry);

        this.countryField.addEventListener('change', (event) => {
          event.stopPropagation();
          const country = this.countryField.value;
          MicLockRegionNotice.chosenCountry = country;
          try {
            sessionStorage.setItem(MicLockRegionNotice.storageKey, country);
          } catch {}
          this.update(country);
          document.dispatchEvent(new CustomEvent('mic-lock:delivery-country', { detail: { country } }));
        }, { signal: this.listeners.signal });

        document.addEventListener('mic-lock:delivery-country', (event) => {
          this.update(event.detail.country);
        }, { signal: this.listeners.signal });
      }

      disconnectedCallback() {
        this.listeners?.abort();
      }

      update(country) {
        const isAvailableOption = Array.from(this.countryField.options).some(option => option.value === country);
        this.countryField.value = isAvailableOption ? country : '';
        const selectedCountry = this.countryField.value;
        const isRestricted = this.restrictedCountries.has(selectedCountry);
        this.unavailable.hidden = !isRestricted;
        this.checkoutHint.hidden = !selectedCountry || isRestricted;
      }
    }

    customElements.define('mic-lock-region-notice', MicLockRegionNotice);
  }
  } catch(e) { console.error(e); }
})();

})();
